import axios from './../api' // 倒入 api



// 个性化
const modifyPersonalize = data => {
  return axios({
    url: `/api/tenant/modify/personalize`,
    method: 'post',
    data
  })
} 
export default {
  modifyPersonalize
}